import { Component, OnInit } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MunicipalityService } from "../../../services/data/municipality.service";
import { ProvinceService } from "../../../services/data/province.service";
import { ActualSelected, Utils } from "../../../shared/utils";
import { ValueService } from "../../../shared/value.service";
import { BankAccountModel } from "../../finanzas/bancos/bankaccount.model";
import { BankAccountService } from "../../finanzas/bancos/bankaccount.service";
import { ModelTaxService } from "../model-tax.service";
import * as FileSaver from 'file-saver';
import { Taxes193Model } from "./taxes-193.model";
import { DialogWorkingComponent } from "../../../shared/components/dialog-working/dialog-working.component";
import { consts } from "../../../consts";

@Component({
    selector: 'convfact-model193',
    templateUrl: './model-193.component.html',
    styleUrls: ['./model-193.component.css'],
    standalone: false
})

export class Model193Component implements OnInit {
  title = 'Modelo 193 - Declaración de retenciones por capital mobiliario';
  KEY_PATH = 'PATH_URL_MODEL_193';

  public data: Taxes193Model = new Taxes193Model();
  validations: Taxes193Model;

  public isLoading: boolean = false;

  path: string;

  bankAccounts: BankAccountModel[];

  provinces: any = [];
  municipalities: any = [];
  street_types: any[];
  locations_types: any[];
  numbering_types: any[];
  modalities: any[];

  constructor(
    public snackBar: MatSnackBar,
    private modelTaxService: ModelTaxService<Taxes193Model>,
    private valueService: ValueService,
    private bankAccountService: BankAccountService,
    private provinceService: ProvinceService,
    private municipalityService: MunicipalityService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.dialog.open(DialogWorkingComponent);
    this.getPath();

    const actualDate: Date = new Date();
    const numeroMes = actualDate.getMonth() + 1;
    const periodo = Math.ceil(numeroMes / 3);

    this.data.ejercicio = ActualSelected.yearSelected;
    this.data.periodo = periodo + "T";


    this.valueService.getList('STREET_TYPE').then(response => {
      this.street_types = response.data;
    });

    this.valueService.getList('LOCATION_TYPE').then(response => {
      this.locations_types = response.data;
    });

    this.valueService.getList('NUMBERING_TYPE').then(response => {
      this.numbering_types = response.data;
    });

    this.valueService.getList('OPERATION_MODALITY').then(response => {
      this.modalities = response.data;
    });

    this.loadProvinces();

    this.getData();
    this.getBankAccounts();
    // let actualDate: Date = new Date();
    // let numeroMes = actualDate.getMonth() + 1;
    // let periodo = Math.ceil(numeroMes / 3);
    // this.periodFormControl.setValue(periodo + "T");

    // this.loadModelo193();
  }

  getData() {
    this.isLoading = true;

    this.modelTaxService.getData({ period: this.data.periodo, receiptNumber: this.data.declaracionComplementaria }, this.data).then(response => {
      this.isLoading = false;
      this.data = response;

      this.onChangeProvince();

      this.recalculateTotal();
    }).catch(err => {
      this.displayInfo("Ha ocurrido un error inesperado al obtener la información");
      this.isLoading = false;
    });
  }

  loadProvinces() {
    this.provinceService.getList().subscribe(response => {
      this.provinces = response.data;
    });
  }

  onChangeProvince() {
    this.municipalityService.getList({ province_code: this.data.contact.provinceCode }).subscribe(response => {
      this.municipalities = response.data;
    });
  }

  public getFile() {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.isLoading = true;
    // this.data.periodo = this.data.page1_Num_10;
    this.displayInfo("Generando el archivo. Este proceso puede tardar aproximadamente 15 segundos. Agradecemos su paciencia.");

    this.modelTaxService.getFile(this.data)
      .then(response => {
        this.isLoading = false;
        FileSaver.saveAs(response, `${this.data.year}_${this.data.periodo}.dec`);
      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error inesperado al obtener la información");
        this.isLoading = false;
      });
  }

  recalculateTotal() {
    // this.data.casilla_25 = this.data.casilla_3 + this.data.casilla_6 + this.data.casilla_9 + this.data.casilla_12 + this.data.casilla_15 + this.data.casilla_18 + this.data.casilla_20 + this.data.casilla_22 + this.data.casilla_24;

    // this.data.casilla_40 =
    //   this.data.casilla_27 +
    //   this.data.casilla_29 +
    //   this.data.casilla_31 +
    //   this.data.casilla_33 +
    //   this.data.casilla_35 +
    //   this.data.casilla_36 +
    //   this.data.casilla_37 +
    //   this.data.casilla_38 +
    //   this.data.casilla_39;

    // this.data.casilla_41 = this.data.casilla_25 - this.data.casilla_40;

    // this.data.casilla_45 = this.data.casilla_41 + this.data.casilla_42 - this.data.casilla_43 - this.data.casilla_44;
  }

  getPath() {
    this.valueService.getValue(this.KEY_PATH).then(response => {
      // this.path = response.data.data;
    });
  }

  validate() {
    this.isLoading = true;
    // this.data.periodo = this.data.page1_Num_10;

    this.modelTaxService.validate(this.data)
      .then(response => {
        this.isLoading = false;
        this.validations = response;
      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error inesperado al obtener la información");
        this.isLoading = false;
      });
  }

  private displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  redirectFileTax() {
    window.open(this.path, '_blank');
  }

  scrollToElement(key: string) {
    const element = document.getElementById(key);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  getBankAccounts() {
    this.bankAccountService.getList().then(response => {
      this.bankAccounts = response.list;
    });
  }

  formatDate(date: Date): string {
    if (!date) return null;

    // Obtén los componentes de la fecha (año, mes y día)
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Se agrega 1 porque los meses van de 0 a 11
    const day = ('0' + date.getDate()).slice(-2);

    // Formatea la fecha como "yyyy-MM-dd"
    return `${year}-${month}-${day}`;
  }

  openModal(templateRef) {
    this.dialog.open(templateRef, {
      height: '95vh', // Puedes ajustar el tamaño aquí
      width: '100vh',
    });
  }

  closeModal() {
    this.dialog.closeAll();
  }

  public trackByIndex(i: number) { return i; }

}
